import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { CircleAlert, LoaderCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';
import ThemeSwitcher from '../components/ThemeSwitcher';

export default function TokenLoginPage() {
  const [params] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = params.get('t');
    const requestedNext = params.get('next') || '/';
    const next = requestedNext.startsWith('/') && !requestedNext.startsWith('//') ? requestedNext : '/';
    if (!token) { setError(t('tokenLogin.missing')); return; }

    api.maxPoll(token)
      .then((data) => {
        if (data.confirmed && data.access_token) {
          login(data.access_token);
          navigate(next, { replace: true });
        } else {
          setError(t('tokenLogin.invalid'));
        }
      })
      .catch((err) => setError(err.message || t('errors.serviceUnavailable')));
  }, [login, navigate, params, t]);

  return (
    <main className="auth-page">
      <section className="card auth-card text-center" aria-live="polite">
        <div className="card-body py-5">
          <div className="auth-toolbar mb-2">
            <ThemeSwitcher compact />
          </div>
          <img className="auth-logo mb-3" src="/logo.png" alt="" />
          {error ? (
            <>
              <CircleAlert className="icon-feature text-danger mb-3" aria-hidden="true" />
              <p className="text-danger">{error}</p>
              <Link to="/login" className="btn btn-outline-primary">{t('tokenLogin.manual')}</Link>
            </>
          ) : (
            <>
              <LoaderCircle className="icon-feature text-primary mb-3 spin" aria-hidden="true" />
              <p className="text-muted mb-0">{t('tokenLogin.loading')}</p>
            </>
          )}
        </div>
      </section>
    </main>
  );
}
